import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRequest } from './components/functions.jsx';

const NO_NEIGHBORS = { previousId: null, previousLabel: null, nextId: null, nextLabel: null };

/*
  Polaris Page `pagination` that steps to the previous / next record of the same type (by id), without going back to
  the list. `type` is the route segment (/invoices/:id -> 'invoices', see server/services/recordNeighbors.js) and
  `noun` names the record in the tooltips. Returns undefined for a new record.
*/
export default function useRecordPagination(type, id, noun) {
  const navigate = useNavigate();
  const [neighbors, setNeighbors] = useState(NO_NEIGHBORS);
  const isNew = !id || id === 'new';

  useEffect(() => {
    let cancelled = false;
    setNeighbors(NO_NEIGHBORS);
    async function fetchNeighbors() {
      const data = await getRequest(`/api/neighbors/${type}/${id}`);
      if (!cancelled && data) setNeighbors({ ...NO_NEIGHBORS, ...data });
    }
    if (!isNew) fetchNeighbors();
    return () => {
      cancelled = true;
    };
  }, [type, id, isNew]);

  if (isNew) return undefined;
  const hasPrevious = neighbors.previousId != null;
  const hasNext = neighbors.nextId != null;
  return {
    hasPrevious,
    hasNext,
    previousTooltip: hasPrevious ? `Previous ${noun}: ${neighbors.previousLabel}` : undefined,
    nextTooltip: hasNext ? `Next ${noun}: ${neighbors.nextLabel}` : undefined,
    onPrevious: () => navigate(`/${type}/${neighbors.previousId}`),
    onNext: () => navigate(`/${type}/${neighbors.nextId}`)
  };
}
